



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Constants from '@/constants/constants.ts';

import Button, { ButtonSize, ButtonIconSize, IconEnum } from '@/modules/shared/components/button.component.vue';
import RewardCartNavbar from '@/modules/shared/components/reward-cart-navbar.component.vue';
import RewardCard from '@/modules/shared/components/reward-card.component.vue';
import Range, { RangeValueStyle } from '@/modules/shared/components/range.component.vue';
import Select, { SelectOption } from '@/modules/shared/components/select.component.vue';
import OrderModal from '@/modules/loyalty/views/rewards/order-modal/order-modal.view.vue';

import textDecorate from '@/modules/shared/directives/text-decorate.directive.ts';
import number from '@/modules/shared/filters/number.filter.ts';

import UtilsService from '@/modules/core/services/utils.service';


@Component({
    components: {
        Button,
        RewardCard,
        RewardCartNavbar,
        Range,
        Select,
        OrderModal,
    },
    computed: {
        ...mapGetters({
            rewardList: 'getRewardList',
            rewardCategoryList: 'getRewardCategoryList',
            hasRewardList: 'hasRewardList',
            getMaxPoints: 'getMaxPoints',
            getRangeStep: 'getRangeStep',
        }),
    },
    methods: {
        ...mapActions({
            fetchRewardList: 'fetchRewardList',
            fetchRewardListTimeout: 'fetchRewardListTimeout',
            fetchRewardCategoryList: 'fetchRewardCategoryList',
            fetchRewardFilters: 'fetchRewardFilters',
        }),
    },
    directives: {
        textDecorate,
        number,
    },
})
export default class RewardsPartial extends Vue {
    private iconEnum = IconEnum;
    private buttonSize = ButtonSize;
    private buttonIconSize = ButtonIconSize;
    private rewardList!: any;
    private getProfile!: any;
    private fetchRewardCategoryList!: any;
    private fetchRewardList!: any;
    private fetchRewardListTimeout!: any;
    private rewardCategoryList!: any;
    private fetchRewardFilters!: any;
    private getMaxPoints!: number;
    private getRangeStep!: number;
    private hasRewardList!: boolean;
    private rewardCartOpen = false;
    private orderModalOpen = false;
    private rangeValueStyle = RangeValueStyle;
    private literals = {
        title: 'ECO Premios',
        section: 'Catálogo de regalos',
        minPoints: {
            label: 'PUNTOS MÍNIMOS',
        },
        maxPoints: {
            label: 'PUNTOS MÁXIMOS',
        },
        selector: {
            label: 'SELECTOR DE CATEGORÍAS',
            placeholder: 'Elige una categoría',
        },
        rewardListEmpty: 'No hay regalos con los parámetros especificados',
    };
    private requiredPointsFrom = '0';
    private requiredPointsTo = '30000';
    private categorySelected = null;
    private firstLoad = false;


    @Watch('categorySelected')
    private watchProduct(newVal: any, oldVal: any) {
        this.fetchRewardListFilter();
    }

    @Watch('requiredPointsFrom')
    private watchRequiredPointsFrom(newVal: any, oldVal: any) {
        this.fetchRewardListFilter();
    }

    @Watch('requiredPointsTo')
    private watchRequiredPointsTo(newVal: any, oldVal: any) {
        if ( this.firstLoad ) {
            this.fetchRewardListFilter();
        }
    }


    private created() {
        this.initializeComponent();
    }


    get subtitle() {
        return `Obtén recompensas del catálogo utilizando tus puntos.`;
    }

    get categoryOptions() {
        return UtilsService.contructOptions(this.rewardCategoryList);
    }


    private setRewardCartOpen(value: boolean) {
        this.rewardCartOpen = value;
    }

    private setOrderModalOpen(value: boolean) {
        this.orderModalOpen = value;
    }

    private fetchRewardListFilter() {
        let category = null;
        if ( this.categorySelected !== null ) {
            category = (this.categorySelected as any).id;
        }
        this.fetchRewardListTimeout({
            category,
            requiredPointsFrom: this.requiredPointsFrom,
            requiredPointsTo: this.requiredPointsTo,
        });
    }

    private addRewardToCart(rewardId: string) {
        this.$store.dispatch('addRewardToCart', rewardId);
        this.setRewardCartOpen(true);
    }

    private openOrderModal() {
        this.setRewardCartOpen(false);
        this.setOrderModalOpen(true);
    }

    private async initializeComponent() {
        await this.fetchRewardCategoryList();
        await this.fetchRewardFilters();
        this.requiredPointsTo = String(this.getMaxPoints);
        this.fetchRewardList()
            .then((res: any) => {
                this.firstLoad = true;
            });
    }

}
